"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditionEnabled = exports.getAssignmentTypesBySettings = void 0;
var assignment_type_enum_1 = require("../constants/assignment-type.enum");
var getAssignmentTypesBySettings = function (settingOptionsAssign) {
    var assignmentTypes = [];
    if (settingOptionsAssign && settingOptionsAssign.moduleAssessmentsEnabled) {
        assignmentTypes = __spreadArray(__spreadArray([], assignmentTypes, true), [
            assignment_type_enum_1.AssignmentType.EndOfModuleAssessment,
            assignment_type_enum_1.AssignmentType.MidModuleAssessment,
            assignment_type_enum_1.AssignmentType.ModuleAssessment,
            assignment_type_enum_1.AssignmentType.Benchmark,
        ], false);
    }
    if (settingOptionsAssign && settingOptionsAssign.topicQuizEnabled) {
        assignmentTypes.push(assignment_type_enum_1.AssignmentType.TopicQuiz);
    }
    return assignmentTypes;
};
exports.getAssignmentTypesBySettings = getAssignmentTypesBySettings;
var isEditionEnabled = function (districtSettings, assessmentTemplate) {
    var customization = districtSettings === null || districtSettings === void 0 ? void 0 : districtSettings.filter(function (districtSetting) { return districtSetting.isEurekaMath; })[0].options.customization;
    return ((assessmentTemplate.isModuleAssignment && (customization === null || customization === void 0 ? void 0 : customization.moduleAssessmentsEnabled)) ||
        (assessmentTemplate.isTopicQuizAssignment && (customization === null || customization === void 0 ? void 0 : customization.topicQuizEnabled)) ||
        assessmentTemplate.isBenchmarkAssignment ||
        assessmentTemplate.isPureModuleAssignment);
};
exports.isEditionEnabled = isEditionEnabled;
